import { Temporal } from '@js-temporal/polyfill';
import { toWire } from '@powerduck/common/extensions/temporal-extensions';
import TemporalUtils from '@powerduck/common/utils/temporal-utils';

export const serializeInviton = Symbol('serializeInviton');

function serializeInvitonImpl(this: Temporal.PlainDateTime): string {
	return this[toWire](true);
}

export function fromInviton(val: string): Temporal.PlainDateTime {
	return TemporalUtils.fromString(val);
}

declare module '@js-temporal/polyfill' {
	// eslint-disable-next-line ts/no-namespace
	namespace Temporal {
		interface PlainDateTime {
			[serializeInviton]: typeof serializeInvitonImpl;
		}
	}
}

(Temporal.PlainDateTime.prototype as any)[serializeInviton] = serializeInvitonImpl;
